
import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "../Layout/Navbar";
import Footer from "../Layout/Footer";
import LogoutButton from "../components/utils/LogoutButton";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import SidebarSection from "../components/SideBarSection";
import { AuthContext } from "../AuthProvider/AuthProvider";
import { getSidebarSections } from "../components/SideBarConfig";
import { usePortal } from "../AuthProvider/PortalProvider";

const pathToNameMap = {
  "/admin/dashboard": "Dashboard",
  "/admin/customer": "Customers",
  "/admin/products": "Product Brands",
  "/admin/products/stock/list": "Stock Product",
  "/admin/products/stock/pending": "Pending Stock Product",
  "/admin/store/list": "Vendor Store",
  "/admin/product/property/list": "Property",
  "/admin/order/list": "Orders",
  "/admin/customer/order/return": "Rejected Items",
  "/admin/view/list": "Administrators",
  "/admin/permission/list": "Permissions",
  "/admin/roles/list": "Roles",
  "/admin/vendor/list": "Vendor",
  "/admin/activity/log": "Administrator Activity Log",
  "/admin/product/list": "Airtime Products",
  "/admin/billers/list": "Billers",
  "/admin/switchers/list": "Switchers",
  "/admin/product/all/list": "Bills Products",
  "/admin/bills/search": "Search Bills",
  "/admin/category/list": "Product Categories",
  "/admin/help/list": "Help Center",
  "/admin/account/2fa/update/status": "2FA Status",
  "/admin/account/notification/status": "Notification",
  "/admin/password/change": "Change Password",
  "/admin/appsettings/list": "Settings",
  "/admin/slider/list": "Slider",
  "/admin/riders/list": "Riders",
  "/admin/cluster/location": "Cluster Point",
  "/admin/delivery/location": "Delivery Rates Management",
  "/admin/vendor/withdrawal/request": "Withdrawal Request",
  "/admin/vendor/withdrawal/request/approval": "Withdrawal Request Approval",
  "/admin/vendor/withdrawal/request/approval": "Withdrawal Request Second Approval",
  "admin/customer/bills/history": "Customer bills",
  // branch newly created 
  // "/operations/branch/list": "Branch",
  "/operations/branch/list": "Branch",
  "/operations/branch/edit": "Branch",
  "/operations/branch/create": "Branch",
  "/operations/branch/customer": "Branch Customers",
  "/operations/branch/dashboard": "Branch Dashboard",
  "/operations/transactions": "Transactions",
  "/operations/branch/floats": "Floats",
  "/operations/branch/incentives": "Incentives",
  "/operations/branch/expenses": "Expenses",
  "/operations/branch/vouchers": "Vouchers",
  "/operations/branch/product/price": "Product Price",
  "/operations/branch/Wallets": "Wallets",
  "/operations/branch/incentives/pending": "Pending Incentives",
  "/operations/branch/products": "Branch Stock",
  "/operations/branch/products/category": "Branch Product",
  "/operations/branch/product/unit": "Branch Product Category",
  "/operations/branch/customer/reports": "Top Customer Report",
  // "/operations/branch/report": "Report",
  "/operations/branch/reports": "Top Branch Report",
  "/operations/branch/wallets/history": "Wallets History",
  "/operations/branch/transaction/history": "Transaction History",
  // purchase item
  "/operations/branch/purchase/item": "Purchase Stock",
  "/operations/branch/purchase/pending": "Pending Purchase Stock",

  "/operations/branch/remittance": "All Remittance",
  "/operations/branch/remittance/details": "Remittance Details",
  "/operations/branch/remittance/pending": "Pending Remittance",
  "/operations/branch/remittance/pending/details": "Pending Remittance Details",
  "/operations/branch/remittance/process": "Process Remittance",
  "/operations/branch/remittance/process/details": "Process Remittance details",
  "/operations/branch/remittance/deducted": "Deduct Remittance",
  "/operations/branch/remittance/deducted/details": "Deducted Remittance Details",
  // stock monitoring
  "/operations/branch/stock/monitoring": "Branch Stock Monitoring",
};

const MainLayouts = ({ children }) => {
  const { permissions } = useContext(AuthContext);
  const { portal, switchPortal } = usePortal(); // Get the portal from context
  const location = useLocation();

  const [openSections, setOpenSections] = useState({});
  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // const sidebarSections = getSidebarSections(permissions);
  const currentPageName = pathToNameMap[location.pathname] || "Dashboard";
  const isDashboard = location.pathname === "/admin/dashboard";
  const sidebarSections = getSidebarSections(permissions, portal);


  // Function to handle portal switching
  const handlePortalSwitch = (newPortal) => {
    switchPortal(newPortal);
    // Reset open sections when switching portals
    setOpenSections({});
  };

  return (
    <>
      <Navbar handlePortalSwitch={handlePortalSwitch} />
      <div className="w-full pl-[3%] pr-[3%] pt-3 mt-25" style={{ backgroundColor: "#F7F7F7" }}>
        {/* <nav className="bg-gray-200 py-0 px-4 rounded-lg">
          <ol className="list-none p-0 inline-flex">
            <li className="flex items-center">
              <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">Admin</p>
              <ChevronRightIcon />
            </li>
            <li className="flex items-center">
              <p className="text-orange1">{currentPageName}</p>
            </li>
          </ol>
        </nav> */}
        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
          {/* REPLACE THIS EXISTING BREADCRUMB */}
          <ol className="list-none p-0 inline-flex">
            <li className="flex items-center">
              <button
                // onClick={() => handlePortalSwitch("admin")}
                className={`text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2 ${portal === "admin" ? "font-bold" : ""}`}
              >
                Admin
              </button>
              <ChevronRightIcon />
            </li>
            {/* <li className="flex items-center">
              <button
                // onClick={() => handlePortalSwitch("operations")}
                className={`text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2 ${portal === "operations" ? "font-bold" : ""}`}
              >
                Operations
              </button>
              <ChevronRightIcon />
            </li> */}
            <li className="flex items-center">
              <p className="text-orange1">{currentPageName}</p>
            </li>
          </ol>
        </nav>
      </div>

      <div className="flex overflow-hidden rounded-lg pl-[3%] pr-[3%]" style={{ backgroundColor: "#F7F7F7" }}>
        <div className="hidden md:flex md:flex-shrink-0 rounded-2xl border border-grey3 my-4 h-[650px] mb-8">
          <div className="flex flex-col w-64">
            <div className="flex flex-col flex-grow pt-5 overflow-y-auto">
              <div className="flex flex-col flex-grow px-4 mt-2">
                <aside className="flex-1 space-y-1">
                  {/* <Link
                    to="/admin/dashboard"
                    className="block p-2 text-xl font-medium tracking-tighter text-darkGreen3 transition duration-500 ease-in-out transform cursor-pointer hover:text-gray-900 mx-auto mb-3"
                  >
                    Dashboard
                  </Link> */}
                  <Link
                    to={portal === "admin" ? "/admin/dashboard" : "/operations/branch/dashboard"}
                    className="block p-2 text-xl font-medium tracking-tighter text-darkGreen3 transition duration-500 ease-in-out transform cursor-pointer hover:text-gray-900 mx-auto mb-3"
                  >
                    Dashboard
                  </Link>

                  {sidebarSections.map(({ key, title, show, links }) =>
                    show ? (
                      <SidebarSection
                        key={key}
                        title={title}
                        links={links}
                        isOpen={openSections[key]}
                        onToggle={() => toggleSection(key)}
                      />
                    ) : null
                  )}

                  {/* <hr className="border border-lGrey" /> */}
                  <div className="rounded-lg mx-4 mt-2">
                    <LogoutButton />
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col flex-1 w-full overflow-hidden mb-8">
          <main className="relative flex-1 overflow-y-auto focus:outline-none">
            <div className="py-4">
              <div
                className="px-4 mx-auto max-w-7xl sm:px-6 md:px-8 ml-[3%] pr-[8%]"
                style={{ backgroundColor: !isDashboard ? "white" : "" }}
              >
                <div className="container-fluid">
                  <main>{children}</main>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default MainLayouts;

